// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:520px;
margin-top:-200px;
`;

export const ContainerFluidX = styled.div`
margin-top:-1px;
// border:2px dashed red;
width:100%;
min-height:370px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657445792/re-brand/Group_4_ifvqwa.svg');
// background-size:;
background-repeat:no-repeat;
background-position:left;
`;

export const Bagde= styled.div`
// border:2px dashed red;
max-width: 200px;
height: 36px;
background: #CCEDE1;
color: #00A568;
border-radius:5px;
text-align:center;
padding-top:8px;
padding-left:8px;
padding-right:8px;

`;

export const ContainerFluidY = styled.div`
// border:2px dashed red;
margin-top:-280px;
width:100%;
min-height:400px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657446307/re-brand/Vector_1_qa1vko.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:right;
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
min-height: 396px;
`;
export const ContainerX = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
width:91% !important;
`;



export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
// width: 359px;
min-height: 38px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;



export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size:20px;
line-height: 142.5%;
color: #4A4A4A;
b{
font-family: 'Cabinet Grotesk-b', roboto;
font-weight: 500;
}
@media screen and (max-width: 425px) {
    width:auto !important;
}
`;